import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigModulos } from '../../../models/configmodulos.model';
import { AbConfigModulos } from 'app/abstract/full-pages/config-modulos/config-modulos.abstract';

const KEY_CONFIG_MODULOS = "configModulos";

@Injectable({ providedIn: 'root' })
export class ConfigModulosService extends AbConfigModulos {
  configModulos: ConfigModulos;

  constructor(http: HttpClient) {
    super(http);
  }

  public getConfigModulos(): Observable<any> {
    return this.get(`config_modulos/1`);
  }

  public saveConfigModulos(configModulos: ConfigModulos): Observable<any> {
    return this.save(`config_modulos/`, configModulos);
  }

  public getConfigModulosStorage(): ConfigModulos {
    return JSON.parse(sessionStorage.getItem(KEY_CONFIG_MODULOS));
  }

  public saveConfigModulosStorage(configModulos: ConfigModulos) {
    sessionStorage.setItem(KEY_CONFIG_MODULOS, JSON.stringify(configModulos));
  }

}
